<template>
  <div class="pagination">
    <button :disabled="page === 1" @click="$emit('change', page - 1)">
      이전
    </button>
    <button
      v-for="p in totalPages"
      :key="p"
      :class="{ active: page === p }"
      @click="$emit('change', p)"
    >
      {{ p }}
    </button>
    <button :disabled="page === totalPages" @click="$emit('change', page + 1)">
      다음
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  page: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
  pageSize: {
    type: Number,
    default: 5,
  },
});

const totalPages = computed(() => {
  const size = props.pageSize > 0 ? props.pageSize : 1;
  return Math.ceil(props.total / size);
});
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 24px 0;
  flex-wrap: wrap;
}

button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  min-width: 36px;
}

button.active {
  background: #111;
  color: white;
  font-weight: bold;
}

button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
